import { useState } from 'react';
import { Box, Typography, Tabs, Tab } from '@mui/material';
import {
  Add as AddIcon,
  Dashboard as DashboardIcon,
} from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import CvFilteringCreate from './CvFilteringCreate';
import CvFilteringDashboard from './CvFilteringDashboard';

const CvFilteringLayout = () => {
  const { t } = useTranslation();
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      {/* Header */}
      <Box sx={{ p: 3, borderBottom: 1, borderColor: 'divider' }}>
        <Typography variant="h4" component="h1" sx={{ mb: 1 }}>
          {t('cvFiltering.title')}
        </Typography>
        <Typography variant="body1" color="text.secondary">
          {t('cvFiltering.subTitle')}
        </Typography>
      </Box>

      {/* Tabs Navigation */}
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={tabValue} onChange={handleTabChange} aria-label="cv filtering tabs">
          <Tab
            icon={<AddIcon />}
            label={t('cvFiltering.createProcess')}
            id="cv-filtering-tab-0"
            aria-controls="cv-filtering-tabpanel-0"
          />
          <Tab
            icon={<DashboardIcon />}
            label={t('cvFiltering.dashboard')}
            id="cv-filtering-tab-1"
            aria-controls="cv-filtering-tabpanel-1"
          />
        </Tabs>
      </Box>

      {/* Tab Panels */}
      <Box sx={{ p: 3 }}>
        {tabValue === 0 && <CvFilteringCreate onSuccess={() => setTabValue(1)} />}
        {tabValue === 1 && <CvFilteringDashboard />}
      </Box>
    </Box>
  );
};

export default CvFilteringLayout;